import { Link } from "react-router-dom";
import { t } from "ttag";

import { EXTERNAL_LINK } from "@/config/external-links";
import { FullscreenAlert } from "@/shared/ui";
import { LinkBrokenMinimalisticIcon } from "@/shared/ui/icons/formatting/link";
import { getFaqLink } from "@/shared/utils";

interface PaymentErrorAlertProps {
  open: boolean;
}

export const PaymentErrorAlert = ({ open }: PaymentErrorAlertProps) => {
  const faqLink = getFaqLink();

  return (
    <FullscreenAlert.Root open={open}>
      <FullscreenAlert.Content theme="light">
        <FullscreenAlert.Header icon={LinkBrokenMinimalisticIcon}>
          <FullscreenAlert.Title>{t`Oops! There was an error`}</FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`Oops! It looks like there's been a hiccup. Not to worry, though! We've already let our technical support team know, and they'll be reaching out to you with a solution. Thanks for your understanding!`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Cancel variant="secondary" asChild>
            <Link to={EXTERNAL_LINK.HOME}>{t`Back to LevelsRx`}</Link>
          </FullscreenAlert.Cancel>

          <FullscreenAlert.Action asChild>
            <Link to={faqLink}>{t`Contact support`}</Link>
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
